"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KNOWN_CHAINIDS = exports.WEI = exports.BUFFER_8_ZERO = exports.BUFFER_32_ZERO = exports.BUFFER_ZERO = exports.BUFFER_EMPTY = exports.ACCOUNT_ZERO = exports.BUFFER_256_ZERO = void 0;
exports.BUFFER_256_ZERO = Buffer.allocUnsafe(256).fill(0);
exports.ACCOUNT_ZERO = exports.BUFFER_256_ZERO.slice(0, 20);
exports.BUFFER_EMPTY = Buffer.allocUnsafe(0);
exports.BUFFER_ZERO = exports.BUFFER_256_ZERO.slice(0, 1);
exports.BUFFER_32_ZERO = exports.BUFFER_256_ZERO.slice(0, 32);
exports.BUFFER_8_ZERO = exports.BUFFER_256_ZERO.slice(0, 8);
exports.WEI = 1000000000000000000n;
exports.KNOWN_CHAINIDS = new Set([1, 3, 4, 5, 42, 11155111]);
//# sourceMappingURL=constants.js.map